const DAYS = 86400
const WEEKS = 7*DAYS
const MONTHS = 30*DAYS


export default <{[key: string]: {
    label: string
    nextAction?: string
    icon?: string
    description?: string
    color?: string,
    defaultPause?: number
}}>{
    created: {
        label: 'Eingetragen',
        nextAction: 'anfragen',
        description: 'Betrieb wurde eingetragen, aber noch nicht weiter bearbeitet.',
        icon: 'fa fa-list',
        color: 'grey',
        defaultPause: 0
    },
    mailsent: {
        label: 'Per Email angefragt',
        nextAction: 'anrufen',
        description: 'Betrieb wurde per E-Mail angefragt',
        icon: 'fa fa-envelope',
        color: 'grey',
        defaultPause: 7*DAYS
    },
    notreached: {
        label: 'tel. nicht erreicht',
        nextAction: 'erneut versuchen',
        description: 'Betrieb konnte telefonisch nicht erreicht werden',
        icon: 'fa fa-phone-slash',
        color: 'grey',
        defaultPause: 1*DAYS
    },
    cancelled_completely: { 
        label: 'abgesagt (komplett)',
        description: 'Betrieb wird vorraussichtlich nie spenden, z.B. weil sie nichts wegschmeissen oder bereits gute Strukturen für das weiterverwenden haben.',
        icon: 'fa fa-ban',
        color: 'red-10',
        defaultPause: 12*MONTHS
    },
    nonexistent: { 
        label: 'existiert nicht mehr',
        description: 'Betrieb wurde eingestellt, weggezogen, etc.',
        icon: 'fa fa-ban',
        color: 'red-10',
        defaultPause: Infinity
    },
    cancelled: { 
        label: 'abgesagt',
        nextAction: 'nochmal versuchen',
        description: 'Möchte/Kann nichts spenden, es lohnt sich aber es in ein paar Monaten es nochmal zu versuchen. Evtl war es auch von unserer Seite aus nicht möglich etwas abzuholen.',
        icon: 'fa fa-thumbs-down',
        color: 'red-4',
        defaultPause: 2*MONTHS
    },
    discussion: { 
        label: 'diskutieren intern',
        description: 'Sie wissen gerade noch nicht, ob sie was haben, sehen aber mal nach und melden sich dann',
        nextAction: 'Rückruf',
        icon: 'fa fa-comments',
        color: 'yellow-8',
        defaultPause: 3*DAYS
    },
    noted: { 
        label: 'wurden vermerkt',
        description: 'Wir wurden vermerkt und sie kommen auf uns zu, sobald es etwas gibt',
        nextAction: 'nochmal nachfragen',
        icon: 'fa fa-pencil-alt',
        color: 'yellow-8',
        defaultPause: 1*MONTHS
    },
    justNothing: {
        label: 'leider gerade nichts',
        nextAction: 'erneut anfragen',
        description: 'Sie haben leider gerade nichts, würden uns aber sehr gerne unterstützen und wir sollen es doch irgendwann erneut versuchen.',
        icon: 'fa fa-thumbs-down',
        color: 'yellow-8',
        defaultPause: 1*MONTHS
    },
    agreedWayUnclear: {
        label: 'Weg unklar',
        nextAction: 'Abholung klären & melden',
        description: 'Wir können etwas haben, es ist aber noch unklar ob und bis wann wir es abholen können',
        icon: 'fa fa-question-circle',
        color: 'green-4',
        defaultPause: 0
    },

    agreedSending: { 
        label: 'Zusendung angeboten',
        nextAction: 'Adresse zuschicken',
        description: 'Sie können es uns zuschicken. Wir sollten ihnen womöglich noch die Adresse geben.',
        icon: 'fa fa-thumbs-up',
        color: 'green-4',
        defaultPause: 0
    },
    agreedSent: {
        label: 'Paket unterwegs',
        nextAction: 'ankunft überprüfen',
        description: 'Sie haben alle möglichen Daten und werden das Paket wird verschickt bzw die Abholung läuft',
        icon: 'fa fa-shipping-fast',
        color: 'green',
        defaultPause: 0
    },
    agreedPickupOffered: {
        label: 'Abholung möglich',
        nextAction: 'Abholende Infos zuschicken',
        description: 'Es wurde ein Mensch für die Abholung gefunden und dem Unternehmen zugesagt.',
        icon: 'fa fa-car-side',
        color: 'green-4',
        defaultPause: 0
    },
    agreedPickupOrganized: {
        label: 'Abholung geklärt',
        nextAction: 'annahme',
        description: 'Abholung ist geklärt und Mensch hat alle relevanten Infos erhalten.',
        icon: 'fa fa-car-side',
        color: 'green-6',
        defaultPause: 0
    },
    agreedExtern: {
        label: 'Abholung abgegeben',
        description: 'Wir können die Abholung nicht stemmen und haben den Kontakt an Externe weitergeleitet.',
        defaultPause: 3*MONTHS,
        icon: 'fa fa-car-crash',
        color: 'light-blue-4'
    },
    foodRecieved: {
        label: 'Essen erhalten',
        nextAction: 'Danke sagen',
        icon: 'fa fa-box-open',
        color: 'green',
        defaultPause: 0
    },
    done: {
        label: 'erledigt',
        nextAction: 'erneute Anfrage',
        icon: 'fa fa-check',
        color: 'green',
        defaultPause: 3*MONTHS
    }
}
